import React from "react";
import "./About.css";
import { Shield, Users, Award, Clock } from "lucide-react";
import PageSEO from '../components/PageSEO';

function About() {
  const stats = [
    { icon: <Clock size={32} />, value: "20+",    label: "Years of Experience" },
    { icon: <Users size={32} />, value: "5,000+", label: "Clients Served" },
    { icon: <Shield size={32} />, value: "15+",   label: "Insurance Products" },
    { icon: <Award size={32} />, value: "100%",   label: "Licensed Brokers" },
  ];

  return (
    <>
      <PageSEO page="about" />

      <div className="about-page">

        {/* --- Hero --- */}
        <section className="about-hero">
          <div className="about-hero-content">
            <h1>About Keystone Insurance Brokers Ltd</h1>
            <p>Coverage You Can Actually Count On — with integrity, trust, and care.</p>
          </div>
        </section>

        {/* --- Who We Are --- */}
        <section className="about-section">
          <h2>Who We Are</h2>
          <p>
            Keystone Insurance Brokers Ltd is a Surrey-based, independent insurance brokerage
            proudly serving individuals, families, and businesses across British Columbia. For over
            two decades, we have built our reputation on one simple principle: putting our clients
            first. We work with a wide range of trusted Canadian insurers to find coverage that fits
            your life — not just a policy off a shelf.
          </p>
          <p>
            As an independent brokerage, we are not tied to any single insurer. That means we shop
            the market on your behalf, compare options, and advocate for your best interests at every
            step — from getting a quote to filing a claim.
          </p>
        </section>

        {/* --- Stats --- */}
        <section className="about-stats">
          {stats.map((stat, i) => (
            <div className="stat-card" key={i}>
              <div className="stat-icon">{stat.icon}</div>
              <h3>{stat.value}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </section>

        {/* --- Why Choose Us --- */}
        <section className="about-section highlight">
          <h2>Why Choose Us</h2>
          <ul>
            <li>✔ Experienced and licensed insurance professionals</li>
            <li>✔ Independent brokerage — we shop the market for you</li>
            <li>✔ Personalized coverage options tailored to your needs and budget</li>
            <li>✔ Fast, compassionate claims assistance when you need it most</li>
            <li>✔ Serving the Surrey and Greater Vancouver area for 20+ years</li>
            <li>✔ Multilingual service — we speak your language</li>
            <li>✔ Open 7 days a week — we are always available</li>
          </ul>
        </section>

        {/* --- Mission & Values --- */}
        <section className="about-section">
          <h2>Our Mission & Values</h2>
          <p>
            Our mission is to make insurance simple, accessible, and stress-free for every client we
            serve. We believe that great coverage shouldn't require a law degree to understand. Our
            brokers take the time to explain your options clearly, answer every question, and ensure
            you walk away confident in your protection.
          </p>
          <div className="values-grid">
            <div className="value-card">
              <h3>Integrity</h3>
              <p>We act with honesty and fairness in every decision we make.</p>
            </div>
            <div className="value-card">
              <h3>Commitment</h3>
              <p>We are committed to protecting our clients' best interests — always.</p>
            </div>
            <div className="value-card">
              <h3>Trust</h3>
              <p>Our reputation is built on reliability, consistency, and care.</p>
            </div>
            <div className="value-card">
              <h3>Excellence</h3>
              <p>We strive to exceed expectations through quality service and support.</p>
            </div>
          </div>
        </section>

        {/* --- CTA --- */}
        <section className="about-cta">
          <h2>Ready to Get Protected?</h2>
          <p>Talk to one of our brokers today — no pressure, just honest advice.</p>
          <a href="/contact" className="cta-btn">Contact Us</a>
        </section>

      </div>
    </>
  );
}

export default About;